<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button variant="link" class="list-view-icon-btn list-view-icon-btn--primary" :disabled="warmCache.loading"
                        v-b-tooltip.hover.bottom title="Regenera la caché de productos para mejorar la velocidad de navegación en el sitio web"
                        aria-label="Cachear Precios para Navegación Rápida"
                        @click="forceWarmCache">
                <b-spinner small v-if="warmCache.loading" />
                <AppIcon name="lightning" v-else />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 180px;">
              <label class="filter-label">Estado</label>
              <v-select :options="arr.select.active" v-model="filters.active" placeholder="Estado" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="width: 220px;">
              <label class="filter-label">Código o Nombre</label>
              <b-form-input type="text"
                            placeholder="Ingrese un código o nombre de producto"
                            v-model="filters.name"
                            size="sm"
                            v-on:keyup.enter.native="filterProducts">
              </b-form-input>
            </div>
            <div class="list-view-filter" style="width: 180px;">
              <label class="filter-label">Categorías</label>
              <v-select :options="arr.select.categorys" v-model="filters.categorys" placeholder="Categorías" :multiple="false" :select-on-tab="true" @input="filterLoadSubCategorys"></v-select>
            </div>
            <div class="list-view-filter" style="width: 180px;">
              <label class="filter-label">Subcategorías</label>
              <v-select :options="arr.select.subcategorys" v-model="filters.subcategorys" placeholder="Subcategorías" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="width: 150px;" v-if="hasLines">
              <label class="filter-label">Líneas</label>
              <v-select :options="arr.select.lines" v-model="filters.lines" placeholder="Lineas" :multiple="false" :select-on-tab="true" @input="filterLoadSubLines"></v-select>
            </div>
            <div class="list-view-filter" style="width: 150px;" v-if="hasLines">
              <label class="filter-label">Sublíneas</label>
              <v-select :options="arr.select.sublines" v-model="filters.sublines" placeholder="Sublineas" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Publicado</label>
              <v-select :options="arr.select.published" v-model="filters.published" placeholder="Publicado" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Destacados</label>
              <v-select :options="arr.select.featured" v-model="filters.featured" placeholder="Destacados" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Vender</label>
              <v-select :options="arr.select.not_sell" v-model="filters.not_sell" placeholder="Vender" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <b-button variant="outline-dark" size="sm" @click="filterProducts()" v-b-tooltip.hover title="Aplicar filtros"
                      style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card>
            <b-row>
              <b-col sm="12" class="mt-2">
                <b-table class="mb-0 crud-products-web-table app-table"
                        ref="table"
                        responsive
                        sticky-header="60vh"
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.items"
                        :fields="table.fields"
                        :filter="table.filter"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        :tbody-tr-class="rowClass"
                        @row-clicked="onRowClicked"
                        :busy="table.isBusy"
                        v-if="table.items.length || table.isBusy">

                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: field.width }"
                      >
                    </template>

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(id)="data">
                      <b>{{data.item.id}}</b>
                    </template>

                    <template v-slot:cell(sell)="data">
                      <span v-if="!data.item.not_sell" title="Se vende por sitio web">
                          <AppIcon name="cart-plus" class="text-success" />
                      </span>
                      <span v-else title="No se vende por sitio web">
                          <AppIcon name="arrow-down" class="text-danger" />
                      </span>
                    </template>

                    <template v-slot:cell(image)="data">
                      <b-img  :src="data.item.image[0]"
                              fluid
                              class="crud-product-image"
                              v-if="data.item.image"/>
                      <AppIcon name="image"
                              v-else
                              class="h2"
                              v-b-tooltip.hover
                              title="Imagen No Disponible" />
                    </template>

                    <template v-slot:cell(name)="data">
                      <div class="crud-products-title">
                        <span v-if="data.item.code" class="crud-products-code">
                          {{data.item.code}}

                          <span>
                            <b-badge variant="success" v-if="data.item.published">PUBLICADO</b-badge>
                            <b-badge variant="danger" v-else>NO PUBLICADO</b-badge>
                          </span>

                          <span v-if="data.item.featured" title="Producto Destacado">
                              <AppIcon name="local_fire_department" class="text-danger" />
                          </span>
                        </span><br>
                        <span v-b-tooltip.hover :title="data.item.name">{{data.item.name}}</span>
                      </div>
                    </template>

                    <template v-slot:cell(variant)="data">
                      <div v-if="hasColorsWaist">
                        <b-button v-if="data.item.colors_waist.length"
                                  @click="openSub(data.item)"
                                  variant="secondary"
                                  size="sm"
                                  class="crud-products-table-button-variant">
                          {{data.item.colors_waist.length}} Items
                          <AppIcon name="chevron-right" />
                        </b-button>
                        <b-button v-else
                                  @click="openSub(data.item)"
                                  variant="outline-secondary"
                                  size="sm"
                                  v-b-tooltip.hover
                                  title="Cargar Variedades"
                                  class="crud-products-table-button-variant">
                          <AppIcon name="chevron-double-right" />
                        </b-button>
                      </div>
                      <div v-else>
                        <div v-if="hasColors">
                          <b-button v-if="data.item.colors.length"
                                    @click="openSub(data.item)"
                                    variant="secondary"
                                    size="sm"
                                    class="crud-products-table-button-variant">
                            {{data.item.colors.length}} Colores
                            <AppIcon name="chevron-right" />
                          </b-button>
                          <b-button v-else
                                    @click="openSub(data.item)"
                                    variant="outline-secondary"
                                    size="sm"
                                    v-b-tooltip.hover
                                    title="Cargar Colores"
                                    class="crud-products-table-button-variant">
                            <AppIcon name="chevron-double-right" />
                          </b-button>
                        </div>
                        <div v-else>
                          <div v-if="hasWaist">
                            <b-button v-if="data.item.waist.length"
                                      @click="openSub(data.item)"
                                      variant="secondary"
                                      size="sm"
                                      class="crud-products-table-button-variant">
                              {{data.item.waist.length}} Talles
                              <AppIcon name="chevron-right" />
                            </b-button>
                            <b-button v-else
                                      @click="openSub(data.item)"
                                      variant="outline-secondary"
                                      size="sm"
                                      v-b-tooltip.hover
                                      title="Cargar Talles"
                                      class="crud-products-table-button-variant">
                              <AppIcon name="chevron-double-right" />
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right
                                  no-caret
                                  size="sm"
                                  variant="link"
                                  boundary="window"
                                  :toggle-class="isMobileViewport ? 'crud-products-web-action-toggle-labeled' : 'app-table-action-toggle'"
                                  :class="{ 'pull-right': !isMobileViewport }">
                        <template #button-content>
                          <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                          <span v-if="isMobileViewport">Opciones</span>
                        </template>
                        <b-dropdown-item @click="openSub(data.item)">
                          <AppIcon name="visibility" /> Visualizar
                        </b-dropdown-item>
                        <b-dropdown-item @click="edit(data.item)">
                          <AppIcon name="edit" /> Editar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else icon="reports" title="No se encontraron productos" description="Ajustá los filtros para ampliar la búsqueda." />

                <div class="app-table-footer" v-if="table.items.length">
                  <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{table.tablePaginate.total}} registros</span>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-sidebar
          id="sidebar-product-web-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle del Producto"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <b-img :src="itemSelected.image[0]"
                    fluid
                    class="crud-product-image mr-2"
                    v-if="itemSelected.image && itemSelected.image.length" />
            <AppIcon name="image"
                    v-else
                    class="h2 mr-2 text-muted"
                    v-b-tooltip.hover
                    title="Imagen No Disponible" />
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelected.code">
                {{itemSelected.code}}
              </span>
              <div>{{itemSelected.name}}</div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrev"
                        v-b-tooltip.hover
                        title="Producto anterior"
                        @click="goPrev()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNext"
                        v-b-tooltip.hover
                        title="Producto siguiente"
                        @click="goNext()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats">
            <div class="list-view-drawer__stat" :class="{ 'list-view-drawer__stat--warning': !itemSelected.active }">
              <span class="list-view-drawer__stat-label">Estado</span>
              <span class="list-view-drawer__stat-value" :class="{ 'text-success': itemSelected.active }">{{itemSelected.active ? 'Activo' : 'Inactivo'}}</span>
            </div>
            <div class="list-view-drawer__stat" :class="{ 'list-view-drawer__stat--warning': !itemSelected.published }">
              <span class="list-view-drawer__stat-label">Publicado</span>
              <span class="list-view-drawer__stat-value" :class="{ 'text-success': itemSelected.published }">{{itemSelected.published ? 'Publicado' : 'No Publicado'}}</span>
            </div>
            <div class="list-view-drawer__stat" :class="{ 'list-view-drawer__stat--warning': itemSelected.not_sell }">
              <span class="list-view-drawer__stat-label">Vender</span>
              <span class="list-view-drawer__stat-value" :class="{ 'text-success': !itemSelected.not_sell }">{{itemSelected.not_sell ? 'No se vende' : 'Se vende'}}</span>
            </div>
            <div class="list-view-drawer__stat" v-if="itemSelected.featured">
              <span class="list-view-drawer__stat-label">Destacado</span>
              <span class="list-view-drawer__stat-value"><AppIcon name="local_fire_department" class="text-danger" /></span>
            </div>
          </div>

          <div v-if="itemSelected.subcategory">
            <div class="list-view-drawer__section-title">
              <AppIcon name="diagram3" /> Categorías
            </div>
            <div>
              {{itemSelected.subcategory.category.name}} <AppIcon name="chevron-right" /> {{itemSelected.subcategory.name}}
            </div>
          </div>

          <div v-if="hasLines && itemSelected.subline">
            <div class="list-view-drawer__section-title">
              <AppIcon name="diagram3" /> Línea
            </div>
            <div>
              {{itemSelected.subline.line.name}} <AppIcon name="chevron-right" /> {{itemSelected.subline.name}}
            </div>
          </div>

          <div v-if="hasMeasurement">
            <div class="list-view-drawer__section-title">
              <AppIcon name="straighten" /> Atributos
            </div>
            <div>
              Profundidad: {{itemSelected.depth}} cm. — Largo: {{itemSelected.long}} cm. — Alto: {{itemSelected.height}} cm. — Peso: {{itemSelected.weight}} kg.
            </div>
          </div>

          <!-- VARIANTES -->
          <div v-if="hasColorsWaist">
            <div class="list-view-drawer__section-title">
              <AppIcon name="palette" /> Color + Talle
            </div>
            <b-table id="table-color-waist"
                      class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSubColorsWaist.items"
                      :fields="tableSubColorsWaist.fields"
                      v-if="tableSubColorsWaist.items.length">

              <template v-slot:cell(color)="data">
                <AppIcon v-if="data.item.color.hexa" name="square" fill class="crud-product-table-show" :style="'color:' + data.item.color.hexa" />
                <b-img v-else-if="data.item.color.plot" :src="data.item.color.plot" :height="30" class="crud-product-table-show" />
                {{data.item.color.name}}
              </template>

              <template v-slot:cell(waist)="data">
                {{data.item.waist.name}}
              </template>

              <template v-slot:cell(f_action)="data">
                <b-dropdown no-caret size="sm" variant="outline-secondary" boundary="window">
                  <template #button-content>
                    <AppIcon name="more_vert" label="Opciones" class="mr-1" /> Opciones
                  </template>
                  <b-dropdown-item @click="editSub(data.item)">
                    <AppIcon name="edit" /> Editar
                  </b-dropdown-item>
                </b-dropdown>
              </template>

            </b-table>
            <EmptyState v-else icon="palette" title="Sin variedades de color + talle" />
          </div>
          <div v-else>
            <div v-if="hasColors">
              <div class="list-view-drawer__section-title">
                <AppIcon name="palette" /> Color
              </div>
              <b-table class="app-table app-table--compact"
                        responsive
                        stacked
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="tableSubColors.items"
                        :fields="tableSubColors.fields"
                        v-if="tableSubColors.items.length">

                <template v-slot:cell(color)="data">
                  <AppIcon v-if="data.item.color.hexa" name="square" fill class="crud-product-table-show" :style="'color:' + data.item.color.hexa" />
                  <b-img v-else-if="data.item.color.plot" :src="data.item.color.plot" :height="30" class="crud-product-table-show" />
                  {{data.item.color.name}}
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown no-caret size="sm" variant="outline-secondary" boundary="window">
                    <template #button-content>
                      <AppIcon name="more_vert" label="Opciones" class="mr-1" /> Opciones
                    </template>
                    <b-dropdown-item @click="editSub(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeSub(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

              </b-table>
              <EmptyState v-else icon="palette" title="Sin variedades de color" />
            </div>

            <div v-if="hasWaist">
              <div class="list-view-drawer__section-title">
                <AppIcon name="straighten" /> Talle
              </div>
              <b-table class="app-table app-table--compact"
                        responsive
                        stacked
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="tableSubWaist.items"
                        :fields="tableSubWaist.fields"
                        v-if="tableSubWaist.items.length">

                <template v-slot:cell(waist)="data">
                  {{data.item.waist.name}}
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown no-caret size="sm" variant="outline-secondary" boundary="window">
                    <template #button-content>
                      <AppIcon name="more_vert" label="Opciones" class="mr-1" /> Opciones
                    </template>
                    <b-dropdown-item @click="editSub(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeSub(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

              </b-table>
              <EmptyState v-else icon="straighten" title="Sin variedades de talle" />
            </div>
          </div>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="edit(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Editar
            </b-button>
          </div>
        </div>
      </b-sidebar>

      <b-row>
        <b-col lg="12">
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>

              <nav v-if="table.tablePaginate">
                <b-pagination class="mb-0"
                              size="sm"
                              pills
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterProducts()" />
              </nav>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              size="xl"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-tabs card>
          <b-tab no-body>
            <template #title><AppIcon name="description" class="mr-1" /> General</template>
            <b-row>
              <b-col md="3">
                <b-form-group label="Código">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.code"
                                required
                                placeholder="Ingresar un código"
                                :disabled="true">
                  </b-form-input>
                </b-form-group>
              </b-col>                   
              <b-col md="9">
                <b-form-group label="Nombre">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.name"
                                required
                                placeholder="Ingresar un nombre"
                                :disabled="true">
                  </b-form-input>
                </b-form-group>
              </b-col>             
            </b-row>     

            <b-row>   
              <b-col md="6">
                <b-row>   
                  <b-col md="12">                
                    <FindObject type="productsCategory" 
                                @select-object="loadProductsCategory($event)" 
                                :valueID="crud.form.category_id"
                                tag="Categorías"
                                render="search"
                                :disabled="true"/>
                  </b-col>
                  <b-col md="12">                    
                    <FindObject type="productsSubCategory" 
                                @select-object="loadProductsSubcategory($event)" 
                                :valueID="crud.form.subcategory_id"
                                tag="Sub Categoría"
                                render="search"
                                :disabled="true"/>
                  </b-col>
                </b-row>                                
              </b-col>               
              <b-col md="6" v-if="hasLines">
                <b-row>
                  <b-col md="12">                                
                    <FindObject type="productsLine" 
                                @select-object="loadProductsLine($event)" 
                                :valueID="crud.form.line_id"
                                tag="Lineas"
                                render="search"
                                :disabled="true"/>
                  </b-col>                
                  <b-col>
                    <FindObject type="productsSubLine" 
                                @select-object="loadProductsSubline($event)" 
                                :valueID="crud.form.subline_id"
                                render="search"
                                :disabled="true"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row> 
              <b-col md="12">
                <b-form-group label="Descripción Corta">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.description_short"                                
                                placeholder="Ingresar una descripción">
                  </b-form-input>
                </b-form-group>
              </b-col>              
            </b-row>
          </b-tab>
        
          <b-tab no-body>
            <template #title><AppIcon name="image" class="mr-1" /> Detalle</template>
            <b-row>
              <b-col md="4">
                <b-row>
                  <b-col md="12">
                    <b-form-group label="Galería">
                      <Imagen :images="crud.form.image" 
                              @load-image="crud.form.image = $event" 
                              typeImage="Imagenes" 
                              :multipleImage="true" 
                              :compressImage="true"
                              :addWaterMark="true"/>
                    </b-form-group>                            
                  </b-col>           
                </b-row>
              </b-col>
              <b-col md="8">
                <b-row>
                  <b-col md="12">
                    <b-tabs card>
                      <b-tab no-body>
                        <template #title><AppIcon name="description" class="mr-1" /> Descripción</template>
                        <b-row>
                          <b-col md="12">
                            <vue-editor class="product-web-ql-editor" v-model="crud.form.description"></vue-editor>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <b-tab no-body>
                        <template #title><AppIcon name="article" class="mr-1" /> Descripción Extendida</template>
                        <b-row>
                          <b-col md="12">
                            <vue-editor class="product-web-ql-editor" v-model="crud.form.description_extended"></vue-editor>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <b-tab no-body>
                        <template #title><AppIcon name="tune" class="mr-1" /> Opciones</template>
                        <b-row>
                          <b-col md="12">                    
                            <b-form-checkbox v-model="crud.form.published" 
                                              switch 
                                              size="sm" 
                                              class="pull-left">
                              Publicado (muestra en sitio web)
                            </b-form-checkbox>            
                          </b-col>                  
                          <b-col md="12" class="mt-3">   
                            <hr>
                          </b-col>                          
                          <b-col md="12" class="mt-3">                    
                            <b-form-checkbox v-model="crud.form.featured" 
                                              switch 
                                              size="sm" 
                                              class="pull-left">
                              Destacado (muestra en bloque destacados)
                            </b-form-checkbox>            
                          </b-col>      
                          <b-col md="12" class="mt-3">   
                            <hr>
                          </b-col>
                          <b-col md="12" class="mt-3">                    
                            <b-form-checkbox v-model="crud.form.not_sell" 
                                              switch 
                                              size="sm" 
                                              class="pull-left">
                              No vender desde sitio web (Se activa la funcionalidad de la solapa "Externo")
                            </b-form-checkbox>            
                          </b-col>                          
                          <b-col md="12" class="mt-3">                    
                            <b-form-checkbox v-model="crud.form.not_decimal_price_website" 
                                              switch 
                                              size="sm" 
                                              class="pull-left">
                              Ocultar los decimales del precio en sitio web (Redondea el importe al visualizar el precio)
                            </b-form-checkbox>            
                          </b-col>                                                                                        
                        </b-row>
                      </b-tab>                      
                      <b-tab no-body>
                        <template #title><AppIcon name="paperclip" class="mr-1" /> Adjuntos</template>
                        <b-row>
                          <b-col md="12">
                            <b-row>
                              <b-col md="6">
                                <b-form-group label="Nombre">            
                                  <b-form-input type="text"
                                                size="sm"
                                                v-model="crud.form.file_name"                                
                                                placeholder="Ingresar un nombre">
                                  </b-form-input>          
                                </b-form-group>                      
                              </b-col>                                                          
                              <b-col md="6">
                                <b-form-group label="Archivo">                
                                  <b-form-file v-if="!crud.form.fileLink" 
                                                v-model="crud.form.file"                             
                                                size="sm"
                                                :state="Boolean(crud.form.file)"
                                                placeholder="Elija un archivo o sueltelo aquí..."
                                                drop-placeholder="Suelta el archivo aquí...">
                                  </b-form-file>      
                                  <div v-else>
                                    <b-link :href="crud.form.fileLink" target="_blank">
                                      <b>Ver Archivo</b>
                                    </b-link>           
                                    <b-button type="button" variant="outline-dark" size="sm" class="btn-pill ml-2" @click="crud.form.fileLink=''" v-b-tooltip.hover title="Cargar otro archivo">
                                      <AppIcon name="refresh" />
                                    </b-button>                                         
                                  </div>
                                </b-form-group>
                              </b-col>                                  
                            </b-row>
                          </b-col>       

                          <b-col md="12">
                            <b-row>
                              <b-col md="6">
                                <b-form-group label="Nombre">            
                                  <b-form-input type="text"
                                                size="sm"
                                                v-model="crud.form.file1_name"                                
                                                placeholder="Ingresar un nombre">
                                  </b-form-input>          
                                </b-form-group>                      
                              </b-col>                                                          
                              <b-col md="6">
                                <b-form-group label="Archivo">                
                                  <b-form-file v-if="!crud.form.file1Link" 
                                                v-model="crud.form.file1"                             
                                                size="sm"
                                                :state="Boolean(crud.form.file1)"
                                                placeholder="Elija un archivo o sueltelo aquí..."
                                                drop-placeholder="Suelta el archivo aquí...">
                                  </b-form-file>      
                                  <div v-else>
                                    <b-link :href="crud.form.file1Link" target="_blank">
                                      <b>Ver Archivo</b>
                                    </b-link>           
                                    <b-button type="button" variant="outline-dark" size="sm" class="btn-pill ml-2" @click="crud.form.file1Link=''" v-b-tooltip.hover title="Cargar otro archivo">
                                      <AppIcon name="refresh" />
                                    </b-button>                                         
                                  </div>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>  

                          <b-col md="12">
                            <b-row>
                              <b-col md="6">
                                <b-form-group label="Nombre">            
                                  <b-form-input type="text"
                                                size="sm"
                                                v-model="crud.form.file2_name"                                
                                                placeholder="Ingresar un nombre">
                                  </b-form-input>          
                                </b-form-group>                      
                              </b-col>                                                          
                              <b-col md="6">                            
                                <b-form-group label="Archivo">                
                                  <b-form-file v-if="!crud.form.file2Link" 
                                                v-model="crud.form.file2"                             
                                                size="sm"
                                                :state="Boolean(crud.form.file2)"
                                                placeholder="Elija un archivo o sueltelo aquí..."
                                                drop-placeholder="Suelta el archivo aquí...">
                                  </b-form-file>      
                                  <div v-else>
                                    <b-link :href="crud.form.file2Link" target="_blank">
                                      <b>Ver Archivo</b>
                                    </b-link>           
                                    <b-button type="button" variant="outline-dark" size="sm" class="btn-pill ml-2" @click="crud.form.file2Link=''" v-b-tooltip.hover title="Cargar otro archivo">
                                      <AppIcon name="refresh" />
                                    </b-button>                                         
                                  </div>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>

                          <b-col md="12">
                            <b-row>
                              <b-col md="6">
                                <b-form-group label="Nombre">            
                                  <b-form-input type="text"
                                                size="sm"
                                                v-model="crud.form.file3_name"                                
                                                placeholder="Ingresar un nombre">
                                  </b-form-input>          
                                </b-form-group>                      
                              </b-col>                                                          
                              <b-col md="6">                            
                                <b-form-group label="Archivo">                
                                  <b-form-file v-if="!crud.form.file3Link" 
                                                v-model="crud.form.file3"                             
                                                size="sm"
                                                :state="Boolean(crud.form.file3)"
                                                placeholder="Elija un archivo o sueltelo aquí..."
                                                drop-placeholder="Suelta el archivo aquí...">
                                  </b-form-file>      
                                  <div v-else>
                                    <b-link :href="crud.form.file3Link" target="_blank">
                                      <b>Ver Archivo</b>
                                    </b-link>           
                                    <b-button type="button" variant="outline-dark" size="sm" class="btn-pill ml-2" @click="crud.form.file3Link=''" v-b-tooltip.hover title="Cargar otro archivo">
                                      <AppIcon name="refresh" />
                                    </b-button>                                         
                                  </div>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>                                                                                                        
                        </b-row>                   
                      </b-tab>
                      <b-tab no-body>
                        <template #title><AppIcon name="link" class="mr-1" /> Externo</template>
                        <b-row>
                          <b-col md="12">
                            <b-alert show variant="info">
                              Si el producto no se vende desde el sitio web, se muestra un botón con redirección al link externo.<br>
                              Sino está configurado, se visulizará un formulario de contacto.
                            </b-alert>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label="Icono Link Externo" description="Icono del link externo mostrado en el botón del sitio web">
                              <b-form-input type="text"
                                            size="sm"
                                            v-model="crud.form.icon_link_external"                                
                                            placeholder="Ingresar un icono de https://fontawesome.com/. Ej: fas fa-inbox">
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label="Leyenda Link Externo" description="Leyenda del link externo mostrado en el botón del sitio web">
                              <b-form-input type="text"
                                            size="sm"
                                            v-model="crud.form.legend_link_external"                                
                                            placeholder="Ingresar una leyenda">
                              </b-form-input>
                            </b-form-group>
                          </b-col>                   
                          <b-col md="12">
                            <b-form-group label="Link Externo" description="Link para más información sobre el producto">
                              <b-form-input type="text"
                                            size="sm"
                                            v-model="crud.form.link_external"                                
                                            placeholder="Ingresar un Link">
                              </b-form-input>
                            </b-form-group>
                          </b-col>                               
                        </b-row>                        
                      </b-tab>
                    </b-tabs>
                  </b-col>           
                </b-row>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body>
            <template #title><AppIcon name="videocam" class="mr-1" /> Videos</template>
            <b-button variant="outline-success" @click="addItemVideoProducts()" class="mb-3" size="sm">
              <AppIcon name="add" class="mr-1" /> Agregar Video
            </b-button>
            <b-alert show variant="primary">
              <h4 class="alert-heading">Formatos de videos disponibles</h4>
              <p>
                <AppIcon name="chevron-right" /> Videos con extensiones (mp4, avi, etc).<br>
                <AppIcon name="chevron-right" /> URL de desde (youtube, vimeo, dailymotion, coub)<br>
                <AppIcon name="chevron-right" /> iFrame desde cualquier plataforma
              </p>
            </b-alert>

            <b-input-group v-for="(element, index) in videosTMP" v-bind:key="index" class="mt-1" >
              <b-input-group-text>
                <AppIcon name="videocam" />
              </b-input-group-text>

              <b-form-input type="text"
                            v-model="videosTMP[index].link"
                            placeholder="URL del video">
              </b-form-input>

              <b-input-group-append>
                <b-button variant="link" class="app-table-icon-btn app-table-icon-btn--danger" @click="deleteItemVideoProducts(element)" v-b-tooltip.hover title="Eliminar Videos">
                  <AppIcon name="delete" label="Eliminar Videos" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-tab>

          <b-tab no-body v-if="!hasAnyVariant">
            <template #title><AppIcon name="tags" class="mr-1" /> Variantes</template>
            <b-row>
              <b-col lg="12">
                <b-form-group label="Variantes" 
                              description="Esta variante del producto se visualizará en el detalle del producto y el cliente podrá informar cantidades para cada item (solo a nivel información)">                
                  <b-form-tags
                    v-model="crud.form.variants"
                    @input="crud.form.newVariants=''"
                    tag-variant="success"
                    class="mb-2 mt-2"
                    no-outer-focus
                    placeholder="Ingrese una variante y haga click en agregar"
                    :state="stateProductVariant"
                  >
                    <template v-slot="{tags, inputId, placeholder, addTag, removeTag }">
                      <b-input-group>                        
                        <b-form-input
                          v-model="crud.form.newVariants"
                          :id="inputId"
                          :placeholder="placeholder"   
                          size="sm"       
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button @click="addTag(crud.form.newVariants)" 
                                            variant="primary"
                                            size="sm">
                            Agregar
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <b-form-invalid-feedback :state="stateProductVariant">
                        Variante duplicada, no se puede agregar.
                      </b-form-invalid-feedback>
                      <ul v-if="tags.length > 0" class="mb-0">
                        <li v-for="tag in tags" :key="tag" :title="`Variante: ${tag}`" class="mt-2">
                          <span  class="d-flex align-items-center">
                            <span class="mr-2">{{ tag }}</span>
                            <b-button                            
                              size="sm"
                              variant="outline-danger"
                              @click="removeTag(tag)"
                            >
                              Quitar
                            </b-button>
                          </span>
                        </li>
                      </ul>
                      <b-form-text v-else>
                        Aun no cargo ninguna variante.
                      </b-form-text>
                    </template>
                  </b-form-tags>          
                </b-form-group>      
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body v-if="hasMeasurement">
            <template #title><AppIcon name="straighten" class="mr-1" /> Atributos</template>
            <b-row>
              <b-col md="6">
                <b-row>
                  <b-col md="12">
                    <b-form-group label="Profundidad" description="Ingrese la medida en cm">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.form.depth"
                                    required
                                    :disabled="isCostSuppliersProducts"
                                    placeholder="Ingresar una profundidad">
                      </b-form-input>
                    </b-form-group>
                  </b-col>    
                  <b-col md="12">
                    <b-form-group label="Largo" description="Ingrese la medida en cm">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.form.long"
                                    required
                                    :disabled="isCostSuppliersProducts"
                                    placeholder="Ingresar un largo">
                      </b-form-input>
                    </b-form-group>
                  </b-col>    
                  <b-col md="12">
                    <b-form-group label="Alto" description="Ingrese la medida en cm">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.form.height"
                                    required
                                    :disabled="isCostSuppliersProducts"
                                    placeholder="Ingresar un alto">
                      </b-form-input>
                    </b-form-group>
                  </b-col> 
                  <b-col md="12">
                    <b-form-group label="Peso" description="Ingrese el peso en kg">
                      <b-form-input type="number"
                                    size="sm"
                                    v-model="crud.form.weight"
                                    required
                                    :disabled="isCostSuppliersProducts"
                                    placeholder="Ingresar un peso">
                      </b-form-input>
                    </b-form-group>
                  </b-col>                   
                </b-row>
              </b-col>
              <b-col md="6">
                <b-row>
                  <b-col md="12" v-if="!hasColors && !hasColorsWaist">
                    <FindObject type="productsColors" 
                                render="search"
                                @select-object="loadAttributeColor($event)" 
                                :valueID="crud.form.attribute_colors_id"                                  
                                tag="Color"/>
                  </b-col>
                  <b-col md="12" v-if="!hasColors && !hasColorsWaist">
                    <b-link @click="goToColors()" class="pull-right">Administrar Colores</b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body>
            <template #title><AppIcon name="link" class="mr-1" /> Relacionados</template>
            <b-row>
              <b-col lg="6">
                <b-form-group label="Opciones de vista">
                  <b-form-select v-model="crud.form.product_related_type_view" :options="optProductRelatedTypeView"></b-form-select>      
                </b-form-group>
              </b-col>
              <b-col lg="6" v-if="crud.form.product_related_type_view=='show_product_related_subcategory'">
                <b-form-group label="Subcategorias" v-if="optProductRelatedSubcategory">
                  <b-form-select v-model="crud.form.product_related_subcategory_id" :options="optProductRelatedSubcategory"></b-form-select>      
                </b-form-group>
              </b-col>         
              <b-col lg="6" v-if="crud.form.product_related_type_view=='show_product_specific'">
                <b-form-group label="Productos" v-if="optProductRelatedSpecific" description="Para activar el buscador, ingrese como mínimo 3 letras">
                  <v-select @search="loadProductSpecificTypeView"
                            :options="optProductRelatedSpecific"
                            v-model="crud.form.product_related_specific" 
                            placeholder="Selecionar Productos" 
                            :multiple="true" 
                            :select-on-tab="true">
                  </v-select>                  
                </b-form-group>
              </b-col>                                  
            </b-row>            
          </b-tab>            
        </b-tabs>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD SUB -->
      <b-modal v-model="modal.formSub.active"
              size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formSub.title}}</h5>
        </div>

        <b-tabs card>

          <b-tab no-body>
            <template #title><AppIcon name="tags" class="mr-1" /> Variantes</template>
            <b-row>
              <b-col md="12">
                <FindObject type="products"
                            @select-object="loadVarietyProducts($event)" 
                            :valueID="crud.formSub.products_id"
                            tag="Producto"
                            disabled/>
              </b-col>
                        
              <b-col md="3">
                <b-form-group label="Código">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.formSub.code"
                                required
                                placeholder="Ingresar un código"
                                :disabled="true">
                  </b-form-input>
                </b-form-group>
              </b-col>                   
              <b-col md="9">
                <b-form-group label="Nombre">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.formSub.name"
                                required
                                placeholder="Ingresar un nombre"
                                :disabled="true">
                  </b-form-input>
                </b-form-group>
              </b-col> 
            
              <b-col md="12">
                <b-row> 
                  <b-col md="4">                                                                       
                    <b-form-group label="Variante">
                      <b-form-select v-model="crud.formSub.typeVariant" 
                                     :options="arr.select.typeVariant" 
                                     :disabled="true"></b-form-select>
                    </b-form-group>                
                  </b-col>
                  <b-col v-show="crud.formSub.typeVariant=='COLOR' || crud.formSub.typeVariant=='COLOR-WAIST'">                    
                      <FindObject type="productsColors" 
                                  @select-object="loadVarietyColors($event)" 
                                  :valueID="crud.formSub.colors_id"                                  
                                  tag="Color"
                                  :disabled="true"/>
                  </b-col>
                  <b-col v-show="crud.formSub.typeVariant=='WAIST' || crud.formSub.typeVariant=='COLOR-WAIST'">
                      <FindObject type="productsWaist" 
                                  @select-object="loadVarietyWaist($event)" 
                                  :valueID="crud.formSub.waist_id"                                  
                                  tag="Talle"
                                  :disabled="true"/>
                  </b-col>               
                </b-row>            
              </b-col> 
            </b-row>
          </b-tab>  

          <b-tab no-body>
            <template #title><AppIcon name="image" class="mr-1" /> Detalle</template>
            <b-row>
              <b-col md="4">
                <b-form-group label="Galería">
                  <Imagen :images="crud.formSub.image"
                          @load-image="crud.formSub.image = $event" 
                          typeImage="Imagenes" 
                          :multipleImage="true" 
                          :compressImage="true"
                          :addWaterMark="true"/>
                </b-form-group>                            
              </b-col>
              <b-col md="8">              
                <b-row>
                  <b-col md="12" v-if="hasColors && !hasWaist && !hasColorsWaist">                    
                    <b-form-checkbox v-model="crud.formSub.published" 
                                      switch 
                                      size="sm" 
                                      class="pull-left">
                      Publicado (muestra en sitio web)
                    </b-form-checkbox>            
                  </b-col>                        
                  <b-col md="12" v-if="hasColors && !hasWaist && !hasColorsWaist">
                    <hr>
                  </b-col>           
                  <b-col md="12">
                    <b-form-group label="Descripción">
                      <vue-editor v-model="crud.formSub.description"></vue-editor>              
                    </b-form-group>      
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formSub.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveSub()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'  
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'
  import Imagen from '@/components/inc/image/image' 
  import Param from '@/config/parameters'
  import { VueEditor } from "vue2-editor";
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      Imagen,
      FindObject,
      VueEditor,
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.PRODUCTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudProductsWeb',
          elements: {}
        }, 
        codeProduct: 0,
        parameters: {
          haveLines: Helper.hasParametersAccess(Param.P7),
          haveColors: Helper.hasParametersAccess(Param.P8),
          haveWaist: Helper.hasParametersAccess(Param.P9),
          haveMeasurement: Helper.hasParametersAccess(Param.P10),
          haveColorsWaist: Helper.hasParametersAccess(Param.P17),
        },
        // Persistido en StorageLocal (ver watcher filtersOpen).
        filtersOpen: false,
        // Atado al ancho real de la ventana (ver mounted/mobileMql).
        isMobileViewport: false,
        detailDrawer: false,
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },        
        tableSubColors : {
          items: [],
          fields: []
        },   
        tableSubWaist : {
          items: [],
          fields: []
        },   
        tableSubColorsWaist : {
          items: [],
          fields: []
        },
        crud: {
          form: {
            id: 0,
            name: '',            
            subline: null,
            subline_id: 0,
            subcategory: null,
            subcategory_id: 0,
            customer: null,
            customer_id: 0,
            code: '',
            image: [],            
            depth: 0,
            long: 0,
            height: 0,
            weight: 0,
            attribute_colors_id: 0,
            attribute_colors: null,
            active: true,
            featured: false,
            description: '',            
            description_short: '',     
            fileLink: '',
            file: null,
            file_name: '',
            published: true,
            fields_optionals: '',
            product_related_type_view: 'default',
            product_related_subcategory_id: 0,
            refused: false,
            variants: [],
            newVariants: '',
            erp_iva_condition: null,
            erp_iva_condition_id: 0,
            accounting_accounts: null,
            accounting_accounts_id: 0,
            videos: [],
            unit_measurement_purchase: null,
            unit_measurement_purchase_id: 0,
            unit_measurement_sale_id: 0,
            unit_measurement_sale: null,
            unit_measurement_sale_conversion: 0,
            haveCostProductPurchase: false,
            published_instagram: false,
            observations: '',
            barcode: '',
            icon_link_external: '',
            legend_link_external: '',
            link_external: '',
            order: 0,
            show_external_app: false,
            description_extended: '',            
            file1Link: '',
            file1: null,
            file1_name: '',
            file2Link: '',
            file2: null,
            file2_name: '',
            file3Link: '',
            file3: null,
            file3_name: '',
            not_sell: false,
            not_decimal_price_website: false,
            product_related_specific: null,            
          }, 
          formSub: {
            id: 0,
            name: '',
            products: null,
            products_id: 0,
            colors: null,
            colors_id: 0,
            waist: null,
            waist_id: 0,
            code: '',
            image: [],
            description: '',   
            active: true,     
            typeVariant: '',    
            published: true,
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
          formSub: {
            active: false,
            title: ''
          },
        },
        arr: {
          products: [],          
          select:{
            lines: [],
            sublines:[],
            categorys: [],
            subcategorys:[],
            customers: [],
            active:[
              {code:true, label: 'Activo'},
              {code:false, label: 'Inactivo'},              
            ],
            featured:[
              {code:true, label: 'Destacados'},
              {code:false, label: 'Sin Destacar'},              
            ],
            published:[
              {code:true, label: 'Publicado'},
              {code:false, label: 'Sin Publicar'},              
            ],                         
            typeVariant: [
              { value: 'COLOR', text: 'COLOR' },
              { value: 'WAIST', text: 'TALLE' },                 
              { value: 'COLOR-WAIST', text: 'COLOR + TALLE' },                 
            ],
            not_sell:[
              {code:false, label: 'Se vende por sitio web'},  
              {code:true, label: 'No se vende por sitio web'},                          
            ],                      
          }          
        },   
        filters: {
          lines: null,
          sublines: null,
          categorys: null,
          subcategorys: null,
          name: '',
          active: {code:true, label: 'Activo'},
          featured: null,
          published: null,          
          onlyEditForWeb: true,
          not_sell: null,
        },
        itemSelected: null,   
        itemSelectedVariant: null,
        modulesActive: [],
        optProductRelatedTypeView: [
          { text: 'Mostrar productos de su misma categoría', value: 'default', },
          { text: 'Mostrar productos de una subcategoría especifica', value: 'show_product_related_subcategory', },
          { text: 'Mostrar productos específicos', value: 'show_product_specific',}
        ],
        optProductRelatedSubcategory: [],
        optProductRelatedSpecific: [],
        videosTMP: [],
        warmCache: {
          loading: false
        }
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {      
      this.modulesActive = Session.getSession().auth.user.permissions.modules      
      this.codeProduct = this.$route.params.codeProduct
      
      if(this.codeProduct){
        this.filters.name = this.codeProduct
      }
      
      this.loadFieldTable()
      this.filterLoad()

      this.filterProducts()

      this.filtersOpen = StorageLocal.getValue('filters_open_crud_products_web') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    computed: {
      hasLines() {
        return this.parameters.haveLines
      },
      hasWaist() {
        return this.parameters.haveWaist
      },
      hasColors() {
        return this.parameters.haveColors
      },
      hasColorsWaist() {
        return this.parameters.haveColorsWaist
      },
      hasAnyVariant() {
        return this.hasColors || this.hasWaist || this.hasColorsWaist
      },
      hasAllVariant() {
        return this.hasColors && this.hasWaist && this.hasColorsWaist
      },
      hasMeasurement() {
        return this.parameters.haveMeasurement
      },
      // NAVEGACION DEL DRAWER (anterior/siguiente sobre las filas cargadas)
      currentIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrev() {
        return this.currentIndex > 0
      },
      canGoNext() {
        if(this.currentIndex < 0) {
          return false
        }
        return this.currentIndex < (this.table.items.length - 1)
      },
      stateProductVariant() {
        return this.crud.form.variants.indexOf(this.crud.form.newVariants.trim()) > -1 ? false : null
      },
      isCostSuppliersProducts() {
        var status = false
        this.modulesActive.forEach(element => {
          if(element.id == Modules.COSTOS) {
            status = true
          }
        })
        return status && !this.hasAnyVariant
      },       
    },
    watch: {
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_products_web', value ? 'true' : 'false')
      },
      // Si el viewport cruza el breakpoint mobile (resize/rotación), las
      // clases de alineación de table.fields tienen que recalcularse.
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      // Alineación de columna: en mobile (modo stacked) el valor pasa a
      // apilarse debajo de su label, así que la alineación de columna de
      // desktop (centrado/derecha) no tiene sentido acá — se resuelve en el
      // propio JSON de fields, en vez de pelear contra la clase con CSS.
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      // Resalta la fila cuyo registro está abierto en el drawer.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },
      // Click en la fila abre el drawer de detalle, salvo que el click haya
      // sido sobre un control (el kebab de acciones, un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      goPrev() {
        if(this.canGoPrev) this.openSub(this.table.items[this.currentIndex - 1])
      },
      goNext() {
        if(this.canGoNext) this.openSub(this.table.items[this.currentIndex + 1])
      },
      loadFieldTable () {
        // TABLE PRODUCTOS
        this.table.fields = []
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class:"align-middle " + this.alignClass('text-center'), width:"30px"})
        this.table.fields.push({key: 'sell', label: this.isMobileViewport ? 'Vender' : '', class:"align-middle " + this.alignClass('text-center'), width:"20px"})
        this.table.fields.push({key: 'image', label: this.isMobileViewport ? 'Imagen' : '', class:"align-middle " + this.alignClass('text-center'), width:"60px"})
        this.table.fields.push({key: 'name', label: 'Nombre', class:"align-middle " + this.alignClass(''), width:"230px"})

        if(this.hasAnyVariant) {
          this.table.fields.push({key: 'variant', label: 'Variedades', class:"align-middle " + this.alignClass('text-center'), width:"100px"})
        }
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"60px"})

        // TABLE PRODUCTO COLOR
        this.tableSubColors.fields = []
        this.tableSubColors.fields.push({key: 'color', label: 'Color', class:"align-middle", width:"150px"})
        this.tableSubColors.fields.push({key: 'f_action', label:'Acción', class:"align-middle", width:"60px"})

        // TABLE PRODUCTO TALLE
        this.tableSubWaist.fields = []
        this.tableSubWaist.fields.push({key: 'waist', label: 'Talle', class:"align-middle", width:"150px"})
        this.tableSubWaist.fields.push({key: 'f_action', label:'Acción', class:"align-middle", width:"60px"})

        // TABLE PRODUCTO COLOR-TALLE
        this.tableSubColorsWaist.fields = []
        this.tableSubColorsWaist.fields.push({key: 'color', label: 'Color', class:"align-middle", width:"150px"})
        this.tableSubColorsWaist.fields.push({key: 'waist', label: 'Talle', class:"align-middle", width:"100px"})
        this.tableSubColorsWaist.fields.push({key: 'f_action', label:'Acción', class:"align-middle", width:"60px"})
      },
      getRowCount (items) {
        return items.length
      },
      openDetail(index) {
        this.table.rowSelected = index          
        this.filterProducts()        
      },       
      load() {
        let loader = this.$loading.show();
        var result = serviceAPI.obtenerProducto()

        result.then((response) => {
          var data = response.data
          this.table.items = data
          this.arr.products = data

          this.table.items.forEach(element => {
            if(!element.active) {
              element._rowVariant = 'danger'  
            }
          });
          
          if(this.table.rowSelected!=null) {
            this.table.items[this.table.rowSelected]._showDetails = true                   
          }  
          loader.hide()         
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });        
      },
      edit(item) {
        let loader = this.$loading.show();
        
        this.crud.form.id = item.id
        this.crud.form.name = item.name              

        if(item.subline) {
          this.crud.form.line_id = item.subline.line_id          
          this.crud.form.subline_id =  item.subline_id        
        } else {
          this.crud.form.line_id = 0          
          this.crud.form.subline_id = 0            
        }
        
        if(item.subcategory) {
          this.crud.form.category_id = item.subcategory.category_id          
          this.crud.form.subcategory_id = item.subcategory_id
        } else {
          this.crud.form.category_id = 0          
          this.crud.form.subcategory_id = 0          
        }

        this.crud.form.customer_id = item.customer_id
        this.crud.form.code = item.code
        this.crud.form.image = item.image        
        this.crud.form.depth = item.depth
        this.crud.form.long = item.long
        this.crud.form.height = item.height
        this.crud.form.weight = item.weight
        this.crud.form.attribute_colors_id = (item.attribute_colors_id!=null) ? item.attribute_colors_id : 0
        this.crud.form.active = item.active
        this.crud.form.featured = item.featured
        this.crud.form.description = item.description      
        this.crud.form.description_short = (item.description_short!=null) ? item.description_short : ''
        this.crud.form.file = null
        this.crud.form.fileLink = item.attach    
        this.crud.form.file_name = (item.attach_name!=null) ? item.attach_name : ''
        this.crud.form.published = item.published
        this.crud.form.product_related_type_view = (item.product_related_type_view!=null) ? item.product_related_type_view : 'default'
        this.crud.form.product_related_subcategory_id = (item.product_related_subcategory_id!=null) ? item.product_related_subcategory_id : 0
        this.crud.form.refused = item.refused   
        this.crud.form.published_instagram = item.published_instagram
        this.crud.form.observations = (item.observations!=null) ? item.observations : ''     
        this.crud.form.barcode = (item.barcode!=null) ? item.barcode : ''
        this.crud.form.icon_link_external = (item.icon_link_external!=null) ? item.icon_link_external : ''
        this.crud.form.legend_link_external = (item.legend_link_external!=null) ? item.legend_link_external : ''
        this.crud.form.link_external = (item.link_external!=null) ? item.link_external : ''
        this.crud.form.order = item.order
        this.crud.form.show_external_app = item.show_external_app
        this.crud.form.description_extended = (item.description_extended!=null) ? item.description_extended : ''
        this.crud.form.file1 = null
        this.crud.form.file1Link = item.attach_one
        this.crud.form.file1_name = (item.attach_one_name!=null) ? item.attach_one_name : ''
        this.crud.form.file2 = null
        this.crud.form.file2Link = item.attach_two
        this.crud.form.file2_name = (item.attach_two_name!=null) ? item.attach_two_name : ''
        this.crud.form.file3 = null
        this.crud.form.file3Link = item.attach_three
        this.crud.form.file3_name = (item.attach_three_name!=null) ? item.attach_three_name : ''
        this.crud.form.not_sell = item.not_sell
        this.crud.form.not_decimal_price_website = item.not_decimal_price_website

        if(item.product_related_specific) {
          let product_related_specific = JSON.parse(item.product_related_specific)
          
          if(Array.isArray(product_related_specific) &&
             product_related_specific[0] && 
             product_related_specific[0]["code"] &&
             product_related_specific[0]["label"]) {

              this.crud.form.product_related_specific = product_related_specific
          } else {            
            this.crud.form.product_related_specific = null
          }          
        } else {
          this.crud.form.product_related_specific = null
        }        

        if(item.variants) {
          this.crud.form.variants = item.variants.split(',')
          this.crud.form.newVariants = ''
        } else {
          this.crud.form.variants = []
          this.crud.form.newVariants = ''          
        }
                
        if(item.image) {          
          this.crud.form.image = []
          item.image.forEach(element => {
            this.crud.form.image.push({ path: element })
          });                    
        } else {
          this.crud.form.image = []
        }

        this.videosTMP = []
        if(item.videos)
          this.videosTMP = JSON.parse(item.videos)
                                
        if(item.product_purchase) {
          this.crud.form.unit_measurement_purchase = item.product_purchase.unit_measurement_purchase
          this.crud.form.unit_measurement_purchase_id = item.product_purchase.unit_measurement_purchase_id
          this.crud.form.haveCostProductPurchase = true
        } else {
          this.crud.form.unit_measurement_purchase = item.unit_measurement_purchase
          this.crud.form.unit_measurement_purchase_id = item.unit_measurement_purchase_id
          this.crud.form.haveCostProductPurchase = false
        }

        this.crud.form.unit_measurement_sale = item.unit_measurement_sale
        this.crud.form.unit_measurement_sale_id = item.unit_measurement_sale_id 
        this.crud.form.unit_measurement_sale_conversion = item.unit_measurement_sale_conversion

        this.crud.form.erp_iva_condition = item.erp_iva_condition
        this.crud.form.erp_iva_condition_id = item.erp_iva_condition_id

        if(item.accounting_account){
          this.crud.form.accounting_accounts = item.accounting_account.accounting_account
          this.crud.form.accounting_accounts_id = item.accounting_account.accounting_accounts_id  
        } else {
          this.crud.form.accounting_accounts = null
          this.crud.form.accounting_accounts_id = 0
        }

        this.loadSubcategoryTypeView()

        setTimeout(()=>{
          this.modal.form._id = Math.random().toString(36).slice(2, 8)
          this.modal.form.title = "Editar Producto"
          this.modal.form.active = true

          loader.hide()
        },500)
      },
      save() {
        let loader = this.$loading.show();

        var image = new FormData();
        this.crud.form.image.forEach((value, key) => {
          image.append(key, value.path);
        })

        var file = new FormData();
        if(this.crud.form.fileLink) {
          file.append("file", this.crud.form.fileLink);
        } else {        
          if(this.crud.form.file) {          
            file.append("file", this.crud.form.file);
          }
        }  
        var file1 = new FormData();
        if(this.crud.form.file1Link) {
          file1.append("file1", this.crud.form.file1Link);
        } else {        
          if(this.crud.form.file1) {          
            file1.append("file1", this.crud.form.file1);
          }
        }          
        var file2 = new FormData();
        if(this.crud.form.file2Link) {
          file2.append("file2", this.crud.form.file2Link);
        } else {        
          if(this.crud.form.file2) {          
            file2.append("file2", this.crud.form.file2);
          }
        }          
        var file3 = new FormData();
        if(this.crud.form.file3Link) {
          file3.append("file3", this.crud.form.file3Link);
        } else {        
          if(this.crud.form.file3) {          
            file3.append("file3", this.crud.form.file3);
          }
        }          

        this.crud.form.videos = JSON.stringify(this.videosTMP)
        
        // armo el array de id para los producto relacionados especificos 
        if (this.crud.form.product_related_specific) {
          this.crud.form.product_related_specific = JSON.stringify(this.crud.form.product_related_specific);
        } else {
          this.crud.form.product_related_specific = null
        }

        var result = serviceAPI.editarProducto(JSON.stringify(this.crud.form), image, file, file1, file2, file3);        

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.filterProducts(true)
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },  
      
      addItemVideoProducts() {
        this.videosTMP.push({
          link: ''
        })
      },
      deleteItemVideoProducts(item) {
        var i = this.videosTMP.indexOf( item );
    
        if ( i !== -1 ) {
            this.videosTMP.splice( i, 1 );
        }
      },

      editSub(item) {        
        this.crud.formSub.id = item.id        
        this.crud.formSub.name = item.name           
        this.crud.formSub.products_id = item.products_id
        this.crud.formSub.colors_id = item.colors_id
        this.crud.formSub.waist_id = item.waist_id
        this.crud.formSub.code = item.code
        this.crud.formSub.image = item.image
        this.crud.formSub.description = item.description
        this.crud.formSub.active = item.active
        this.crud.formSub.published = item.published

        if(this.hasColorsWaist) {
          this.crud.formSub.typeVariant = 'COLOR-WAIST'
        } else {
          if(this.hasColors) {
            this.crud.formSub.typeVariant = 'COLOR'
          } else {
            this.crud.formSub.typeVariant = 'WAIST'
          }
        }

        if(item.image) {          
          this.crud.formSub.image = []
          item.image.forEach(element => {
            this.crud.formSub.image.push({ path: element })
          });                    
        } else {
          this.crud.formSub.image = []
        }

        this.modal.formSub.title = "Editar Variedad"
        this.modal.formSub.active = true
      },
      saveSub() {
        let loader = this.$loading.show();

        var image = new FormData();
        this.crud.formSub.image.forEach((value, key) => {
          image.append(key, value.path);
        })

        var typeVariant = this.getTypeVariant()

        var result = serviceAPI.editarVariedad(JSON.stringify(this.crud.formSub), image, typeVariant);        

        result.then((response) => {
          this.modal.formSub.active = false                   
          this.filterProducts(true)     
          loader.hide()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },      
      loadAttributeColor(object) {
        if(object){
          this.crud.form.attribute_colors = object
          this.crud.form.attribute_colors_id = object.id
        } else {
          this.crud.form.attribute_colors = null
          this.crud.form.attribute_colors_id = 0
        }
      },


      loadProductsLine (object) {
        if(object){
          this.crud.form.line = object
          this.crud.form.line_id = object.id
          //this.crud.form.subline = null
          //this.crud.form.subline_id = 0          
        } else {
          this.crud.form.line = null
          this.crud.form.line_id = 0
          //this.crud.form.subline = null
          //this.crud.form.subline_id = 0          
        }
      },  
      loadProductsSubline (object) {
        if(object){
          this.crud.form.subline = object
          this.crud.form.subline_id = object.id
        } else {
          this.crud.form.subline = null
          this.crud.form.subline_id = 0
        }
      },  
      loadProductsCategory (object) {
        if(object){
          this.crud.form.category = object
          this.crud.form.category_id = object.id
          //this.crud.form.subcategory = null
          //this.crud.form.subcategory_id = 0          
        } else {
          this.crud.form.category = null
          this.crud.form.category_id = 0
          //this.crud.form.subcategory = null
          //this.crud.form.subcategory_id = 0          
        }
      },           
      loadProductsSubcategory (object) {
        if(object){
          this.crud.form.subcategory = object
          this.crud.form.subcategory_id = object.id                    
        } else {
          this.crud.form.subcategory = null
          this.crud.form.subcategory_id = 0
        }
      },   
      loadVarietyProducts (object) {
        if(object){
          this.crud.formSub.products = object
          this.crud.formSub.products_id = object.id
        } else {
          this.crud.formSub.products = null
          this.crud.formSub.products_id = 0
        }
      }, 
      loadVarietyColors (object) {
        if(object){
          this.crud.formSub.colors = object
          this.crud.formSub.colors_id = object.id
        } else {
          this.crud.formSub.colors = null
          this.crud.formSub.colors_id = 0
        }
      }, 
      loadVarietyWaist (object) {
        if(object){
          this.crud.formSub.waist = object
          this.crud.formSub.waist_id = object.id
        } else {
          this.crud.formSub.waist = null
          this.crud.formSub.waist_id = 0
        }
      },    
      loadProductsCustomer (object) {
        if(object){
          this.crud.form.customer = object
          this.crud.form.customer_id = object.id                   
        } else {
          this.crud.form.customer = null
          this.crud.form.customer_id = 0
        }
      },
      loadSubcategoryTypeView () {
        var result = serviceAPI.obtenerCategoria()

        result.then((response) => {
          var data = response.data              
          
          this.optProductRelatedSubcategory = []
          data.forEach(element => {
            element.subcategorys.forEach(element1 => {      
              this.optProductRelatedSubcategory.push({text: element.name + ' - ' + element1.name, value: element1.id})                                                            
            });                                
          });       
        })         
        .catch(error => {
          this.optProductRelatedSubcategory = []
        })
      },
      loadProductSpecificTypeView (search, loading) {        
        loading(true)
        if(search && search.length>2) {
          var result = serviceAPI.filtrarProducto({
            name: search
          },1);

          result.then((response) => {
            var data = response.data.data              
            
            this.optProductRelatedSpecific = []
            data.forEach(element => {            
              this.optProductRelatedSpecific.push({label: element.code + " - " + element.name, code: element.id})                                                                        
            });       

            loading(false)
          })         
          .catch(error => {
            this.optProductRelatedSpecific = []
          })
        }
      },      
      filterLoad() {
        this.filterLoadLines()
        this.filterLoadCategorys()
      },
      filterLoadLines() {
        var result = serviceAPI.obtenerLinea()        
        result.then((response) => {
          var data = response.data    
          
          data.forEach(element => {      
            this.arr.select.lines.push({code: element.id, label: element.name})                                                            
          });                                
        })   
      },
      filterLoadSubLines(val) {        
        this.arr.select.sublines=[]
        if(val) {
          var result = serviceAPI.obtenerLinea()        
          result.then((response) => {
            var data = response.data    
            
            data.forEach(element => {         
              if(element.id == val.code) {
                element.sublines.forEach(element1 => {
                  this.arr.select.sublines.push({code: element1.id, label: element1.name})                        
                }); 
              }
            });                                
          })   
        }
      },
      filterLoadCategorys() {
        var result = serviceAPI.obtenerCategoria()        
        result.then((response) => {
          var data = response.data    

          data.forEach(element => {              
            this.arr.select.categorys.push({code: element.id, label: element.name})                        
            /*
            element.subcategorys.forEach(element1 => {
              this.arr.select.subcategorys.push({category: element.name, subcategory: element1.name, code: element1.id})                        
            });
            */                                    
          });                                
        })   
      },   
      filterLoadSubCategorys(val) {
        this.arr.select.subcategorys = []
        if(val) {          
          var result = serviceAPI.obtenerCategoria()        
          result.then((response) => {
            var data = response.data    

            data.forEach(element => {          
              if(element.id == val.code) {
                element.subcategorys.forEach(element1 => {
                  this.arr.select.subcategorys.push({code: element1.id, label: element1.name})
                }); 
              }                                  
            });                                
          })   
        }
      },

      filterProducts(forceOpenVariant=false) {
        this.table.isBusy = true
        var result = serviceAPI.filtrarProducto(this.filters, this.table.currentPage)        
        result.then((response) => {          
          var data = response.data
          this.table.tablePaginate = data
          this.table.items = data.data          
          this.arr.products = data.data  

          this.table.items.forEach(element => {
            if(!element.active) {
              element._rowVariant = 'danger'                          
            }
            
            if(forceOpenVariant && this.itemSelected) {
              if(element.id == this.itemSelected.id) {
                this.openSub(element)
              }
            }
          });

          if(this.table.rowSelected!=null) {            
            this.table.items[this.table.rowSelected]._showDetails = true                   
          }   
                    
          if(this.$refs.table) {            
            this.$refs.table.$forceUpdate()
          }          
          
          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(ErrorToken.valid(error));
        })
      },

      forceWarmCache() {
        this.warmCache.loading = true

        var result = serviceAPI.forzarCachePrecios()
        result.then((response) => {
          this.warmCache.loading = false
          this.$awn.success(response.data.message || "El proceso de caché se ha iniciado en segundo plano. Esto puede tardar unos minutos.");
        })
        .catch(error => {
          this.warmCache.loading = false
          this.$awn.alert(Error.showError(error));
        })
      },

      getTypeVariant() {
        var typeVariant = ''
        if(this.hasAllVariant) {          
          if(this.crud.formSub.typeVariant=='COLOR') {
            typeVariant = 'COLOR'
          }
          if(this.crud.formSub.typeVariant=='WAIST') {
            typeVariant = 'WAIST'
          }   
          if(this.crud.formSub.typeVariant=='COLOR-WAIST') {
            typeVariant = 'COLOR-WAIST'
          }                    
        } else {        
          if(this.hasColors) {
            typeVariant = 'COLOR'
          }

          if(this.hasWaist) {
            typeVariant = 'WAIST'
          }          

          if(this.hasColorsWaist) {
            typeVariant = 'COLOR-WAIST'
          }          
        }
        return typeVariant
      },
      getTypeVariantAlt() {
        var typeVariant = ''        
        if(this.hasAnyVariant) {                        
          if(this.hasColors) {
            typeVariant = 'COLOR'
          }

          if(this.hasWaist) {
            typeVariant = 'WAIST'
          }          

          if(this.hasColorsWaist) {
            typeVariant = 'COLOR-WAIST'
          }          
        }
        return typeVariant
      },
      getVariantProduct(item) {
        if(item.colors.length || item.waist.length || item.colors_waist.length) {
          return true
        } else {
          return false
        }        
      },      

      openSub(item) {
        this.detailDrawer = true
        this.itemSelected = item

        this.tableSubColors.items = item.colors
        this.tableSubColors.items.forEach(element => {
          if(!element.active) {
            element._rowVariant = 'danger'  
          } else {
            element._rowVariant = ''  
          }
        });          
      
        this.tableSubWaist.items = item.waist
        this.tableSubWaist.items.forEach(element => {
          if(!element.active) {
            element._rowVariant = 'danger'  
          } else {
            element._rowVariant = ''  
          }
        });           
      
        this.tableSubColorsWaist.items = item.colors_waist
        this.tableSubColorsWaist.items.forEach(element => {            
          if(!element.active) {
            element._rowVariant = 'danger'  
          } else {
            element._rowVariant = ''  
          }
        });
      },
      hideSub() {
        this.itemSelected = null
        this.detailDrawer = false
      },

      goToColors() {
        this.$router.push({ name: 'ProductsStaffCrudColors' })
      }
    }    
  }
</script>
<style>
  .crud-products-title {
    font-size: 15px;
    font-weight: 600;
  }
  .crud-products-code {
    color: gray;
  }
  .crud-product-image {
    height: 40px;
  }

  .crud-product-table-show {
    font-size: 15px;
  }
  .crud-products-table-button-variant {
    padding: 2px;
    padding-left: 3px;
    padding-top: 2px;
    padding-bottom: 2px;
  }
  .product-web-ql-editor .ql-editor {
    min-height: 300px !important;
  }
  .btn.crud-products-web-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-products-web-action-toggle-labeled:hover,
  .btn.crud-products-web-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-products-web-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
</style>